// extracted by mini-css-extract-plugin
module.exports = {"chip":"styles_chip__3xAUQ","primary":"styles_primary__QAohE","secondary":"styles_secondary__2eHs_"};